import type { ShowStatus } from '@fetmode/types';

/**
 * Poll GET /shows-by-username while the watcher cannot sit in a live show room:
 * empty storefront, last show ENDED, or WAITING/PAUSED (socket drop fallback).
 */
export function shouldPollShowForGoLive(input: {
  storefrontOnly: boolean;
  status: ShowStatus | null;
}): boolean {
  if (input.storefrontOnly) {
    return true;
  }
  return input.status === 'ENDED' || input.status === 'WAITING' || input.status === 'PAUSED' || input.status === 'AWAY';
}
